export function isJsonObject(value) {
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === "object" && !Array.isArray(parsed);
  } catch {
    return false;
  }
}
